import { useAuth } from "@auth/AuthContext"

import { DEFAULT_GRADE_SCALE, type GradeScale } from "@/types"

/**
 * Reads the active grade scale from the authenticated professor's resolved
 * academic config. Falls back to "0-10" (Mexican secondary norm) when the
 * payload predates PRD-38 (e.g. a cached login response during a deploy).
 *
 * PRD-38 / ADR-0032 (2026-08-01): the scale is now INSTITUTION-owned tenant
 * config (School override → Institution), not a per-professor preference —
 * the Settings "Calificaciones" card is gone. Source moved from
 * `professor.settings.grade_scale` to `professor.academic_config.grade_scale`;
 * the return type is unchanged so every consumer is untouched.
 *
 * Promoted to `src/hooks/` (2026-05-21) so cross-feature consumers
 * (Sidebar, Home, Classrooms, Students, Direction) can read it
 * without importing from a feature folder.
 */
export const useGradeScale = (): GradeScale => {
  const { professor } = useAuth()
  return professor?.academic_config?.grade_scale ?? DEFAULT_GRADE_SCALE
}
